import * as R from 'ramda';

import {createSelector} from 'reselect';
import {getItemsArray} from 'redux/hor/module/selectors';

export const getClientAllRequestsSelector = createSelector(
  state => state.requestsAll,
  getItemsArray
);

export const getClientAllRequestParamsSelector = createSelector(
  state => state.requestsAll,
  R.compose(
    R.pick(['limit', 'offset', 'count']),
    R.defaultTo({})
  )
);